import { configureStore } from '@reduxjs/toolkit'
import { createLogger } from 'redux-logger'

import api from '../middleware/api'
import modal from '../middleware/modal'
import redirectTo from '../middleware/redirect_to'
import pageChangesMonitor from '../middleware/page_changes_monitor'

import rootReducer from '../reducers'

const APP_MIDDLEWARES = [
  api, modal, redirectTo, pageChangesMonitor
]

if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test') {
  const logger = createLogger({
    diff: true,
    collapsed: true
  })
  APP_MIDDLEWARES.push(logger)
}

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(APP_MIDDLEWARES),
  devTools: process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test',
})

export default store
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch